// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	background-color: rgb(229, 231, 235);
} div#root {
	width: min(100%, 1224px);
	margin: 0 auto;
} .App {
  text-align: left;
} .App-logo {
  height: 40vmin;
  pointer-events: none;
} @media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
} .App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
} 
.App-link {
  color: #61dafb;
} @media only screen and (min-width: 768px) {
	#ewh-fascione-hp-comunali
    , #ewh-fascione
    , #ewh-fascione-italia
    , #ewh-fascione-europa
    , #ewh-fascione-hp-speciale
	, #ewh-fascione-hp-elezioni {
   		max-width: 67.32%;
    } #ewh-referendum-mappa-italia
	, #ewh-mappa-italia, #ewh-mappa-italia-ballottaggio {
  		max-width: 300px;
  	}
} @keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
} @media only screen and (max-width: 767.98px) {
	#ewh-fascione-hp-comunali
	, #ewh-fascione
	, #ewh-fascione-italia
	, #ewh-fascione-europa {
		max-width: none;
	}	
} h3 {
	word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;AACrC,EAAE;CACD,wBAAwB;CACxB,cAAc;AACf,EAAE;EACA,gBAAgB;AAClB,EAAE;EACA,cAAc;EACd,oBAAoB;AACtB,EAAE;EACA;IACE,4CAA4C;EAC9C;AACF,EAAE;EACA,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,cAAc;AAChB,EAAE;CACD;;;;;;KAMI,iBAAiB;IAClB,EAAE;;IAEF,gBAAgB;GACjB;AACH,EAAE;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF,EAAE;CACD;;;;EAIC,eAAe;CAChB;AACD,EAAE;CACD,qBAAqB;AACtB","sourcesContent":["body {\n\tbackground-color: rgb(229, 231, 235);\n} div#root {\n\twidth: min(100%, 1224px);\n\tmargin: 0 auto;\n} .App {\n  text-align: left;\n} .App-logo {\n  height: 40vmin;\n  pointer-events: none;\n} @media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n} .App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n} \n.App-link {\n  color: #61dafb;\n} @media only screen and (min-width: 768px) {\n\t#ewh-fascione-hp-comunali\n    , #ewh-fascione\n    , #ewh-fascione-italia\n    , #ewh-fascione-europa\n    , #ewh-fascione-hp-speciale\n\t, #ewh-fascione-hp-elezioni {\n   \t\tmax-width: 67.32%;\n    } #ewh-referendum-mappa-italia\n\t, #ewh-mappa-italia, #ewh-mappa-italia-ballottaggio {\n  \t\tmax-width: 300px;\n  \t}\n} @keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n} @media only screen and (max-width: 767.98px) {\n\t#ewh-fascione-hp-comunali\n\t, #ewh-fascione\n\t, #ewh-fascione-italia\n\t, #ewh-fascione-europa {\n\t\tmax-width: none;\n\t}\t\n} h3 {\n\tword-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
